import React, { useState, useEffect, useMemo, useCallback, useRef, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { fetchOpportunitiesRequest, updateBookmarkSuccess } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { deleteOpportunity, fetchConvertToWin, markAsRelevant, markReadByUser, toogleOppBookmark } from "../../../../services/iqApiV2";

import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import OpportunityFilterContainer from "./opportunityFilterContainer/OpportunityFilterContainer";
import * as FeatherIcon from "react-feather";
import ContactMapCard from "./CardTabs/ContactMapCard";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
// import TagOverflowHandler from "../../uiUtils/TagOverflowHandler";

import "./SpotOpportunities.css";
import TagOverflowHandlerV2 from "../../uiUtils/TagOverflowHandlerV2";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import MemoryContainerSC from "../../../Navigation/memoryComps/MemoryContainerSC";
import { useBanner } from "../../../../context/BannerContext";
import SimpleSearchBar from "../../genericComponents/simpleSearchBar/SimpleSearchBar";
import TR3DotMenu from "../../genericComponents/genericTableComp/TR3DotMenu";
import { useGroupTaskWebSocket } from "../../../../context/GroupTaskWebSocketContext";
import BattleCardV2 from "./CardTabs/BattleCardV2";
import { dynamicSmartSort } from "../../../TableComponents/dynamicSortFunction";
import { ucfirst } from "../../../TableComponents/tableUtils";
import ChampionCard from "./CardTabs/ChampionCard";
import ResizableDivForTag from "../../uiUtils/resizeobs/ResizableDivForTag";
import SimpleBookmark from "../../genericComponents/simpleBookmark/SimpleBookmark";
import { FetchSpotContactsRequest } from "../../../../store/features/actions/targetedReachout/spotContactsActions";
import SpotContactBCV2 from "../TargetedReachOut/troSubTabs/SpotContactBCV2";
import MoveToAutoNurture from "../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/MoveToAutoNurture";
import SimpleThemedButton from "../../genericComponents/simpleTextField/SimpleThemedButton";
import { useAuthorizedUser } from "../../../../context/AuthorizedUserContext";
import StatusIndicator from "../../genericComponents/resizeableTable/StatusIndicator";
import ChipWithEllipse from "./ChipWithEllipse";

const randomIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" className="top_tab_icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#535458" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
);

function SpotOpportunities() {
  const { isAuthorized, isAuthLoading } = useAuthorizedUser();
  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const showBanner = useBanner();
  const { opportunitesData, opportunitesLoading } = useSelector(state => state?.opportunitiesReducer);
  const {getDataById } = useGroupTaskWebSocket();
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [tabData, setTabData] = useState([]);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [showMoreModalForAn, setShowMoreModalForAn] = useState(false);
  
  const [currRow, setCurrRow] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [showMemSc,setShowMemSc]= useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const { spotContactsData, spotContactsLoading } = useSelector(
    (state) => state?.spotContactsReducer
  );

  const initialSortState = {
    sortKey: "",
    sortConfig: {},
  };

  const sortReducer = (state, action) => {
    switch (action.type) {
      case "SET_SORT_KEY":
        return { ...state, sortKey: action.payload };
      case "SET_SORT_CONFIG":{
        const payload = action.payload?{order:action.payload}:{}
        return { ...state, sortConfig: payload };
      }
      default:
        return state;
    }
  };
  const [sortState, dispatchSort] = useReducer(sortReducer, initialSortState);


  const updateSortKey = (value) => {
    console.log("updateSortKey",value)
    dispatchSort({ type: "SET_SORT_KEY", payload: value });
  };

  const updateSortConfig = (value) => {
       console.log("updateSortConfig",value)
    dispatchSort({ type: "SET_SORT_CONFIG", payload: value });
  };
  // const taskStatus = getTaskStatus(`spot_opp_table`);
  const [selectedOpportunity, setSelectedOpportunity] = useState({
    id: null,
    name: null,
    desc: null,
    mainSignal:null,
    relevanceScore:null,
    mappedProducts:null,
    oppLvlUnmetNeed:null, 
    oppLvlSubsignal:null,
    oppLvlBu:null
  });
  const liveOpps = getDataById("spot_opp_table")

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
    }
  }, [clientName, accountName, user?.id, dispatch]);

  const handleConvertTOWin = useCallback(
    async (item) => {
      const postCall=()=>{
             showBanner({ message: 'Moved To Win Opportunities',title:"Alert", type: 'info', duration: 2000 })
      }
      const resp = await fetchConvertToWin([item?._id], user?.id,postCall);
      if (resp) {
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user?.id, type: "spot" }));
      }
    },
    [clientName, accountName, user?.id, dispatch]
  );

const handleBookmarkToggle = async(oppId) => {
  const postCall = (resp) => {
    if (resp !== undefined) {
      dispatch(updateBookmarkSuccess(oppId, resp));
      {resp? showBanner({ message: 'Bookmark Saved',title:"Alert", type: 'success', duration: 2000 }): showBanner({ message: 'Bookmark Removed',title:"Alert", type: 'info', duration: 2000 })}
    }else{
        showBanner({ message: 'Error While Bookmarking',title:"Error", type: 'error', duration: 2000 })
      }
  };

  await toogleOppBookmark(oppId, user?.id, postCall);
};

  const handleMarkAsRelevant = useCallback(
    async (item) => {
      const postCall=()=>{
             showBanner({ message: 'Opportunity has been marked as live',title:"Alert", type: 'info', duration: 2000 })
      }
      //const resp = ""
      const resp = await markAsRelevant([item?._id], user?.id,postCall);
      if (resp) {
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user?.id, type: "spot" }));
      }
    },
    [clientName, accountName, user?.id, dispatch]
  );

const handleSideCard = useCallback(
  async (e, item, tabId = "battle_card_so") => {
    e.preventDefault();
    e.stopPropagation();

    setShowMoreModal(true);
    setSelectedOpportunity({
      id: item?._id,
      name: item?.opportunity_name,
      desc: item?.opportunity_description,
      mainSignal: item.tag,
      relevanceScore: item.relevance,
      mappedProducts:item?.mapped_products,
      oppLvlUnmetNeed:item?.unmet_need, 
      oppLvlSubsignal:item?.sub_signal,
      oppLvlBu:item?.business_unit
    });
    setCurrRow(item);
    setActiveTab(tabId);

    try {
      if (item?.is_read === false) {
        const resp = await markReadByUser(user?.id, item?._id);
        if (resp) {
         dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:user?.id, type: "spot" }));
        }
      }
    } catch (err) {
      console.error("Failed to mark as read:", err);
    }
  },
  [user]
);

const handleSideCardForAutoNurture = useCallback(
  async (e, item) => {
    e.preventDefault();
    e.stopPropagation();

    setShowMoreModalForAn(true);

    setCurrRow(item);

  },
  [user]
);
  const handleDeleteOpp = useCallback(async (e, userId, item) => {
    e.preventDefault();
    e.stopPropagation();
    const resp=  await deleteOpportunity(userId, item?._id); // Pass params if needed
    if (resp) {
      showBanner({ message: 'Deleted From Spot Opportunities',title:"Alert", type: 'success', duration: 5000 })
      dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:userId, type: "spot" }));
    }
  }, []);


  const commonProps = useMemo(() => ({
    opportunityId: selectedOpportunity.id,
    opportunityName: selectedOpportunity.name,
    opportunityDescription: selectedOpportunity.desc,
    mainSignal:selectedOpportunity.mainSignal,
    relevanceScore:selectedOpportunity.relevanceScore,
    mappedProducts:selectedOpportunity?.mappedProducts,
    oppLvlUnmetNeed:selectedOpportunity?.oppLvlUnmetNeed, 
    oppLvlSubsignal:selectedOpportunity?.oppLvlSubsignal,
    oppLvlBu:selectedOpportunity?.oppLvlBu
  }), [selectedOpportunity]);
  const [showContactSc,setShowContactSc]  = useState(null);

  const handleOnContactCardClick=(data)=>{
    setShowContactSc(data)
    setActiveTab("battle_card_sc")
  }

    const handleOnBackClick=()=>{
                setShowContactSc(null)
                   setActiveTab("contact_map_so")
                
                  if (!["battle_card_sc","champion_note_sc"].includes(activeTab)) {
                    setShowMoreModal(false)
                 
                  }
  }

  // console.log("showContactSc",showContactSc)

const tabConfig = useMemo(() => {
  const tabs = [
    {
      key: "battle_card_so",
      tabId: "battle_card",
      label: "Battle Card",
      Component: () => (
        <BattleCardV2
          mainSignal={commonProps.mainSignal}
          opportunityId={commonProps.opportunityId}
          relevanceScore={commonProps.relevanceScore}
          mappedProducts={commonProps.mappedProducts}
          opportunityDescription={commonProps?.opportunityDescription}
          oppLvlSubsignal={commonProps.oppLvlSubsignal}
          oppLvlUnmetNeed={commonProps?.oppLvlUnmetNeed}
          oppLvlBu={commonProps.oppLvlBu}
        />
      ),
      icon: randomIcon,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    },
    {
      key: "contact_map_so",
      tabId: "contact_map",
      label: "Potential Contacts",
      Component: () => (
        <ContactMapCard
          opportunityId={commonProps?.opportunityId}
          contact_list={spotContactsData}
          onContactCardClick={handleOnContactCardClick}
        />
      ),
      icon: randomIcon,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    },{
      key: "auto_nurutre_so",
      tabId: "auto_nurture",
      label: "Auto Nurture",
        dontShow:true,
      Component: () => (
       <MoveToAutoNurture
          currOpp={currRow}
          setShowMoreModalForAn={setShowMoreModal}
        />
      ),
      icon: randomIcon,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    }
  ];



  return tabs;
}, [commonProps]);

console.log("currRow",currRow)


  const tabConfigForContact = useMemo(() => {
    const baseTabs = [
    {
      key: "battle_card_sc",
      label: "Battle Card",
      tabId: "battle_card",
      Component: () => <SpotContactBCV2 contactId={showContactSc?.id} />,
      icon: randomIcon,
      tagIcon: <img src="/img/blueDocIcon.png" width="16"/>,
    },
        ...(clientName === 'MARKETS & MARKETS' ? [{
          key: "champion_note_sc",
          label: "Champion Note",
          tabId: "champion_note",
          Component: () => <ChampionCard contact_name={showContactSc?.name} designation={showContactSc?.title} />,
          icon: randomIcon,
          tagIcon: <img src="/img/blueDocIcon.png" width="16"/>,
        }] : [])
    ];
  
    return [...baseTabs, 
      // ...additionalTabs
    ];
  }, [showContactSc]);

  useEffect(() => {
    if (!opportunitesData?.length) return;

let filtered = opportunitesData?.map(item => {
  let rel = item?.relevance;

  if (typeof rel === 'number') {
    if (rel >= 80 && rel <= 100) rel = 'high';
    else if (rel >= 60 && rel < 80) rel = 'medium';
    else if (rel >= 0 && rel < 60) rel = 'low';
  }

  return {
    ...item,
    relevance: rel
  };
})?.filter(item =>
  Object.entries(filters).every(([key, values]) => {
    // ✅ Skip this filter if no values are selected
    if (!values?.length) return true;

    // Special case: mapped_products
    if (key === "mapped_products") {
      let val = item?.mapped_products;

      if (typeof val === "string") {
        val = val.split(",").map(v => v.trim());
      } else if (!Array.isArray(val)) {
        val = [];
      }

      return val.some(v => values.includes(v));
    }

    const val = item[key.toLowerCase()] ?? item[key];
    return values.includes(val);
  })
);



    filtered = dynamicSmartSort(filtered,sortState.sortKey,sortState.sortConfig);
    // Apply search filter on opportunity_name and tag
    if (searchQuery) { 
      const query = searchQuery?.toLowerCase();
      filtered = filtered.filter(item => {
        const mappedProducts = Array.isArray(item?.mapped_products)
          ? item.mapped_products
          : typeof item?.mapped_products === "string"
            ? item.mapped_products.split(",").map(v => v.trim())
            : [];

        return (
          item?.opportunity_name?.toLowerCase().includes(query) ||
          item?.tag?.toLowerCase().includes(query) ||
          item?.relevance?.toLowerCase().includes(query) ||
          mappedProducts.some(e => e?.toLowerCase().includes(query))
        );
      });
    }
    const enhanced = filtered.map((item) => ({
      ...item,
      is_bookmarked: (
        <div
          style={{
            padding: "0.3rem",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <SimpleBookmark
            key={item?._id}
            isFilled={item?.is_bookmarked}
            users={item?.inFavUsers || []}
            customCallback={async () => {
              await handleBookmarkToggle(item?._id);
            }}
          />
        </div>
      ),
      opportunity_name: (
        <div onClick={(e) => handleSideCard(e, item)}>
          {item.opportunity_name}
        </div>
      ),
      contact_count: (
        <div
          className="opp-user-icon-container"
          onClick={(e) => handleSideCard(e, item)}
        >
          <FeatherIcon.Users
            alt="users"
            style={{ color: "#4B84E9", maxHeight: "1.1rem" }}
            className="mr-1"
          />{" "}
          {item.contact_count}
        </div>
      ),
      relevance: item?.relevance && (
        <div onClick={(e) => handleSideCard(e, item)}>
          <TagOverflowHandlerV2 data={ucfirst(item?.relevance)} />
        </div>
      ),
      tag: (
        <div onClick={(e) => handleSideCard(e, item)}>
          <ChipWithEllipse data={item?.tag} />{" "}
        </div>
      ),
      documents: (
        <ResizableDivForTag
          handleSideCard={handleSideCard}
          items={tabConfig}
          rowData={item}
        />
      ),
      mapped_products: (
        <ResizableDivForTag
          handleSideCard={(e) => handleSideCard(e, item, "battle_card_so")}
          items={(Array.isArray(item?.mapped_products)
            ? item?.mapped_products
            : typeof item?.mapped_products === "string"
            ? item?.mapped_products.split(",").map((s) => s.trim())
            : []
          ).map((e) => ({ key: e, label: e }))}
          rowData={item}
        />
      ),
      is_live: (
        <>
          {!item?.source ? (
            <span className="green">Live</span>
          ) : (
            <button
              className="convert-to-win-btn font11"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleMarkAsRelevant(item);
              }}
            >
              <div>{opportunitesLoading ? <IOSSpinner /> : <>Make Live</>}</div>
            </button>
          )}
        </>
      ),

      actions: (
        <span style={{ display: "flex", gap: "1rem" }}>
          {!item?.auto_nurture_in_progress && (
            <SimpleThemedButton
              variant="outline"
              buttonText={
                <>
                  <img
                    src="/img/Forward.png"
                    alt="move"
                    className="mr-1"
                    width="14"
                  />{" "}
                  Move To Win
                </>
              }
              loaderTxt="Moving to Win"
              onBtnClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleConvertTOWin(item);
              }}
            />
          )}

          
            <>
              {" "}
              {item?.auto_nurture_in_progress && (item?.auto_nurture_status == "draft" || item?.auto_nurture_status == "in_queue") ? (
                <>
               {item?.auto_nurture_status === "draft" ? 
                <StatusIndicator
                  variant="info"
                  text="Nurture is in draft"
                  onClickComp={(e) => {
                    e.preventDefault();
                              e.stopPropagation();
                    handleSideCard(e, item, "auto_nurutre_so")}}
                /> : <StatusIndicator
                        variant="success"
                        text="Nurture in Progress"
                        onClickComp={(e) =>
                        handleSideCard(e, item, "auto_nurutre_so")
                   }
                 />}
                </>
              ) : (
                <SimpleThemedButton
                  variant="outline"
                  buttonText={<> Auto Nurture</>}
                  loaderTxt="Moving to Win"
                  onBtnClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSideCard(e, item, "auto_nurutre_so");
                  }}
                />
              )}
            </>
        </span>
      ),
      moreOptions: (
        <TR3DotMenu
          menuItems={[
            {
              label: "Delete",
              onMenuClick: (e) => handleDeleteOpp(e, user?.id, item),
            },
          ]}
        />
      ),
    }));

    setTabData(enhanced);
  }, [opportunitesData, filters, handleConvertTOWin, handleSideCard, tabConfig,searchQuery,sortState]);


useEffect(() => {
  if (!liveOpps?.length) return;

  const completedOrFailed = liveOpps.filter(
    (item) => item.status === "completed" || item.status === "failed"
  );

  if (completedOrFailed.length === 0) return;

  let count = 0;


  const intervalId = setInterval(() => {
    if (count >= 3) {
      clearInterval(intervalId);
      return;
    }
    dispatch(fetchOpportunitiesRequest({
      clientName,
      accountName,
      userId: user.id,
      type: "spot"
    }));
    count++;
  }, 10000); // Runs every 5s

  return () => clearInterval(intervalId);
}, [liveOpps?.length]);

  

useEffect(() => {
  // Exit early if there's no data to process
  if (!opportunitesData?.length) return;

  // Define the keys we're interested in extracting values from
  const include = ['tag','business_unit', 'mapped_products','relevance'];

  // Initialize an object to collect unique filter values
  const options = {};
  // Loop through each opportunity item
  opportunitesData?.map(item => {
  let rel = item?.relevance;

  if (typeof rel === 'number') {
    // relevance is sometimes coming number . instead of high , medium, low 
    if (rel >= 80 && rel <= 100) rel = 'high';
    else if (rel >= 60 && rel < 80) rel = 'medium';
    else if (rel >= 0 && rel < 60) rel = 'low';
  }

  return {
    ...item,
    relevance: rel
  };
})?.forEach(item => {
    include?.forEach(key => {
      const value = item[key];
      if (!value) return; // Skip if key doesn't exist or is null/undefined

      // Initialize a Set for the key if not already present
      options[key] = options[key] || new Set();

      // Special case: if key is "mapped_products", assume nested array structure
      if (key === "mapped_products") {
        let normalized = [];

        if (typeof value === "string") {
          // Split string by comma and trim whitespace
          normalized = value.split(",").map(v => v.trim());
        } else if (Array.isArray(value)) {
          normalized = value;
        }

        normalized.forEach(val => options[key].add(val));
      }
      // Handle general arrays
      else if (Array.isArray(value)) {
        value?.forEach(val => options[key].add(val));
      }
      // Handle primitive or single string values
      else {
        options[key].add(value);
      }
    });
  })

  // Convert each Set to an array for easier use in dropdowns, filters, etc.

    const formatted = Object.entries(options).reduce((acc, [key, set]) => {
      acc[key] = [...set]?.filter(item => item !== null || item!=undefined);
      return acc;
    }, {});

  // Debug output
  // console.log("formatted", formatted);

  // Set the final structured filter options in state
  // console.log("formatted",formatted)
  setFilterOptions(formatted);
}, [opportunitesData]);


  useEffect(() => {
    setIsMounted(true);
    if (clientName && accountName && user?.id) {
      dispatch(
        FetchSpotContactsRequest({
          clientName,
          accountName,
          userId: user?.id,
          type: "all",
        })
      );
    }
    return () => setIsMounted(false);
  }, [clientName, accountName, user?.id, dispatch]);

  const tableColumns = useMemo(() => {
      const baseColumns = [
        { id: "is_bookmarked", label: "", width: 55, clickAction: true, alignment: "left" },
        { id: "opportunity_name", label: "Opportunity", width: 100, alignment: "flex-start" },
        { id: "tag", label: "Signal", width: 100, alignment: "flex-start" },
        { id: "mapped_products", label: "My Offerings", width: 80, alignment: "flex-start" },
        { id: "contact_count", label: "Contacts", width: 63, alignment: "flex-start" },
        { id: "relevance", label: "Relevance", width: 68, alignment: "flex-start" },
        { id: "documents", label: "Documents", width: 120, alignment: "flex-start", disableColSort: true },
        { id: "is_live", label: "Is Live", width: 80, alignment: "flex-start" },
        { id: "actions", label: "Actions", width: isAuthorized?150:100 ,alignment:"flex-start" ,disableColSort:true},
        { id: "moreOptions", label: "", width: 15, clickAction: true, alignment: "flex-end", disableColSort: true },
      ];

      // Remove 'is_live' if user is an ANALYST
      if (user?.role_key !== "ANALYST") {
        return baseColumns.filter(col => col.id !== "is_live");
      }

      return baseColumns;
  }, [user?.role_key]);

  const filterCount = useMemo(() =>
    Object.values(filters).reduce((acc, val) => acc + (val?.length || 0), 0)
  , [filters]);

  return (
    <>
      <OpportunityFilterContainer
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        type="spot"
        chatbotBtnTxt="Find Opportunities"
        mainTitl="Spot Opportunities before your peers do"
        filterTitl="Filter Opportunities by Solutions,Signals. "
        oppBtnTitl="Or Generate Battle Card, Potential Contacts for your opportunity"
        parentTab={"spot_opp"}
      />

      <div className="find-opportunities-container mounted">
        <span className="find-opportunities-header-container">
          <span className="find-opportunities-header">
            <h6 className="find-opportunities-results-title">
            Showing {opportunitesLoading ? <IOSSpinner /> : tabData?.length || 0} Results
            </h6>

            {filterCount > 0 && (
              <div className="find-opportunities-results-title-filter-badge">
                {filterCount} filters applied
                <img src="/img/x.png" alt="clear" onClick={() => setFilters({})} />
              </div>
            )}
          </span>
        <span style={{display:"flex",justifyContent:"center",flexDirection:"row",alignItems:"center"}}>
            <SimpleSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </span>
        </span>

        <div className="find-opportunities-results-container">
          <GenericTable
          minWidthForDrawer={"60%"}
          loadingRows={15}

          sortState={sortState}
            updateSortKey={updateSortKey}
            updateSortConfig={updateSortConfig}
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={showContactSc?.id ? tabConfigForContact : tabConfig}
            showMoreModal={showMoreModal}
            oppName={commonProps?.opportunityName}
            // setShowMoreModal={setShowMoreModal}
            onModalClose={()=>{setShowContactSc(null); setShowMoreModal(false)}}
            titleForSideCard={
              <ScHeaderComp
                key={`side_card_head_comp_${commonProps?.opportunityId}`}
                type="spot_opportunities" 
                showMoreModal={showMoreModal} 
                data={currRow} 
                // setShowMoreModal={setShowMoreModal} 
                opportunityId={commonProps?.opportunityId} 
                tabConfig={tabConfig} 
                showMemComp={true} 
                memoryType={"single-opportunity"}
                activeTab={activeTab} 
                onBackClick={handleOnBackClick}

              />}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            loading={opportunitesLoading && tabData?.length==0}
          />
        </div>
      </div>


      <GenericOverviewSideCard  

        showMoreModal={showMemSc}
        setShowMoreModal={setShowMemSc}
        titleForSideCard={<div className='mem-sc-titl-cont'><img className='back-btn-img' src="/img/backArrow.png" onClick={()=>setShowMoreModal(false)}/> <span className="span_memory">Memory</span></div>}
        comp={<MemoryContainerSC memoryType="opportunity"/>}
        minWidthForDrawer="30%"
        disableXbtn
        preserveState={false}
        />

    </>
  );
}

export default SpotOpportunities;
